export class SessionServiceError extends Error {
  public constructor(message: string, cause?: unknown) {
    super(message, cause instanceof Error ? { cause } : undefined);
    this.name = 'SessionServiceError';
  }
}
